import { connect } from 'react-redux'
import Checkbox from './Checkbox.js';
import { toggleLabels } from '../../actionCreators';

const mapStateToProps = (state, ownProps) => ({
	checked: state.showLabels
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	onChange: (event) => dispatch(toggleLabels())
});

export default connect(mapStateToProps, mapDispatchToProps)(Checkbox);


// WEBPACK FOOTER //
// ./src/components/Filter/LabelsCheckboxContainer.js